import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Endpoint, HelpIndex, ConflictResolutionType } from '../../../models/enums';
import { FilterTemplateType, GenericColDef, GridContext, GridRowSelectionType, SortByFilter } from '../../../models/grid-context';
import { Organization } from '../../../models/organization';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';
import { GenericGridComponent } from '../../generic-grid/generic-grid.component';

@Component({
  standalone: false,
  selector: 'res-save-to-orgs-modal',
  templateUrl: './save-to-orgs-modal.component.html',
  styleUrls: ['./save-to-orgs-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SaveToOrgsModalComponent extends BaseModalComponent implements OnInit {
  nameConflict: ConflictResolutionType = ConflictResolutionType.OVERWRITE;
  @ViewChild(GenericGridComponent) genericGrid: GenericGridComponent;
  ownerHandle: string;
  constructor(
    private modalService: BsModalService,
    private commonService: CommonService,
    private modalRef: BsModalRef,
    private restService: RestService
  ) {
    super(modalService, modalRef);
  }

  // Modal information
  modalTitle = 'Save to Organizations';
  modalAutomationId = 'save-to-orgs';
  modalClass = 'save-to-orgs';
  modalHelpIndex = HelpIndex.sys_template_profiles_savetoorgs_dlg;
  primaryButtonLabel = 'Save';
  secondaryButtonLabel = 'Cancel';
  isBusy = false;
  isBusyMessage = 'Running ...';

  // grid information
  gridName = 'Save-to-Orgs';
  isGridBusy = false;
  isGridBusyMessage = 'Loading ...';
  rowSelection = GridRowSelectionType.multipleCheckboxWithRowClickSelection;

  gridContext = new GridContext({
    inlineGridFilter: true,
    sortAscending: true,
    sortAscendingFieldName: 'descending',
    sortByFieldName: 'sortByFilter',
    sortBy: SortByFilter.NAME
  });

  requestInfo = {
    endpoint: Endpoint.realmManager_listSystemUserOrgs,
    responseName: 'organizationNames',
    data: {
      count: 0,
      filters: [],
      requestHandle: null,
      startIndex: 0,
      userName: this.commonService.currentUser.name,
      systemScope: true
    }
  };

  columnDefs = new Array<GenericColDef>(
    {
      colId: 'checkbox',
      automationId: '',
      minWidth: 36, maxWidth: 36, width: 36,
      headerCheckboxSelection: true,
      checkboxSelection: true,
      suppressSizeToFit: true,
    },
    {
      headerName: 'Name',
      field: 'organizationName',
      automationId: '',
      defaultSortBy: SortByFilter.NAME,
      filterType: FilterTemplateType.freeform,
      lockVisible: true
    }
  );

  responseArrayCallback = (value: any) => {
    return new Organization({ organizationName: value });
  }

  ngOnInit(): void {
    this.ownerHandle = this.modalData.ownerHandle;
    this.columnDefs.forEach((col) => { col.automationId = this.modalAutomationId });
  }


  save(): void {
    const allRows = [];
    this.isBusy = true;
    this.genericGrid.selectedRows.forEach(row => {
      allRows.push(row.organizationName);
    });
    this.restService.post(Endpoint.templateManager_copyMetaTemplateProfileEntriesToOrganizations, {
      conflictResolutionType: this.nameConflict,
      metaTemplateProfileEntries: null,
      organizations: allRows,
      ownerHandle: this.ownerHandle,
      systemScope: true
    }).then(response => {
      this.isBusy = false;
      this.closeModal();
    }, error => {
      this.isBusy = false;
    });
  }

  okEnabled() {
    return this.genericGrid?.selectedRows?.length > 0;
  }

}
